import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner
} from 'reactstrap'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import AlertMessage from '../../../components/AlertMessage'
import projectExportsActions from './actions'

class ProjectExportRetryConfirmationModal extends React.Component {
  componentDidUpdate(prevProps) {
    const { retryStatus: prevretryStatus } = prevProps
    const { onClose, retryStatus } = this.props

    if (prevretryStatus === 'retrying' && retryStatus === 'succeeded') onClose()
  }

  handleSubmit(event) {
    const { dispatch, projectExportId, projectId } = this.props

    event.preventDefault()

    dispatch(projectExportsActions.retry(projectId, projectExportId))
  }

  render() {
    const {
      isOpen,
      onClose,
      retryError,
      retryStatus,
      t
    } = this.props

    const i18nBase = 'ProjectExports.ProjectExportRetryConfirmationModal'

    return (
      <Modal isOpen={isOpen} toggle={() => onClose()}>
        <Form>
          <ModalHeader toggle={() => onClose()}>
            {t(`${i18nBase}.title`)}
          </ModalHeader>
          <ModalBody>
            <div className="d-flex flex-column">
              <p>{t(`${i18nBase}.bodyMessage`)}</p>
            </div>

            {retryStatus === 'failed' && (
              <AlertMessage>{retryError}</AlertMessage>
            )}
          </ModalBody>
          <ModalFooter>
            <div className="d-flex flex-row flex-fill justify-content-between">
              <div className="d-flex flex-row">
                {retryStatus === 'retrying' && (
                  <>
                    <Spinner className="text-secondary" />
                    <div className="d-flex flex-column justify-content-center">
                      <span className="ms-3">
                        {t(`${i18nBase}.retrying`)}
                      </span>
                    </div>
                  </>
                )}
              </div>

              <div className="d-flex flex-row">
                <Button
                  className="me-2"
                  color="secondary"
                  onClick={() => onClose()}
                >
                  {t('buttons.cancel', { ns: 'commons' })}
                </Button>
                <Button
                  color="primary"
                  onClick={(event) => this.handleSubmit(event)}
                  type="submit"
                >
                  {t('buttons.continue', { ns: 'commons' })}
                </Button>
              </div>
            </div>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
}

ProjectExportRetryConfirmationModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  projectExportId: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  retryError: PropTypes.string,
  retryStatus: PropTypes.string,
  t: PropTypes.func.isRequired
}

ProjectExportRetryConfirmationModal.defaultProps = {
  retryError: null,
  retryStatus: 'idle',
  isOpen: false
}

const mapStateToProps = ({
  projectExports: {
    retryError,
    retryStatus
  }
}) => ({
  retryError,
  retryStatus
})

export default withTranslation(['ProjectsPage', 'commons'])(
  connect(mapStateToProps)(ProjectExportRetryConfirmationModal)
)
